import { urls } from "core/constant/urls"
import { getApi, putApi, postApi } from "./apiClient"
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";

export const fetchUserProfile = async () => {
    try {
        const url = urls?.endpoints?.user?.getUserDetails;
        const response = await getApi(url)
        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateUserProfile = async (values) => {
    try {
        const url = urls?.endpoints?.user?.updateDetails;
        const customHeaders = { 'Content-Type': 'multipart/form-data', };
        const response = await putApi(url, values, customHeaders);
        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateLogo = async (values) => {
    try {
        const url = urls?.endpoints?.user?.logoUpdate;
        const customHeaders = { 'Content-Type': 'multipart/form-data', };
        const response = await putApi(url, values, customHeaders);
        return response
    } catch (error) {
        console.log(error)
    }
}

export const login = async (values, navigate) => {
    try {
        const url = urls?.endpoints?.user?.login;
        const response = await postApi(url, values);
        localStorage.setItem("token", response.data.jwtToken);
        navigate('/');
        window.location.reload();
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getUserFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        return decodedToken?.payload?.user;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const getPermissionFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        return decodedToken?.payload?.permission;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const getRoleFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        return decodedToken?.payload?.role;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const getLogoFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        return decodedToken?.payload?.company?.companyLogo;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const getExpiryDateFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        return decodedToken?.payload?.company?.expiryDate
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const getExpiryDateFromTokenBoolean = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        const expiry = decodedToken?.payload?.company?.expiryDate
        const today = new Date().toISOString()
        if (expiry < today) {
            return true
        }
        else {
            return false
        }
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
};

export const companyAccountStatus = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(token);
        const active = decodedToken?.payload?.company?.active
        return active
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
}